import constants from './constants';

export function loading(requestId) {
  return {
    type: constants.actions.REQUEST_LOADING,
    requestId,
  };
}

export function loaded(requestId) {
  return {
    type: constants.actions.REQUEST_LOADED,
    requestId,
  };
}

export default {
  loading,
  loaded,
};
